import { createStore, getActionIds } from '../helpers/redux';
import Immutable, { Map, List } from 'immutable';

import { ProjectActions } from '../actions/project';
import { RelationshipActions } from '../actions/relationship';
// import { CommentActions } from '../actions/comment';
import { ElementActions } from '../actions/element';
// import { TagActions } from '../actions/tag';
import { elementsRelationshipsSelector } from './elementsRelationships';
import { currentElementIdSelector } from './elements';

// const commentActions = getActionIds(CommentActions);
const elementActions = getActionIds(ElementActions);
const projectActions = getActionIds(ProjectActions);
const relationshipActions = getActionIds(RelationshipActions);
// const tagActions = getActionIds(TagActions);

const initialState = Immutable.fromJS({
  relationships: {},
  loading: {
    relationships: [],
    tags: [],
    comments: [],
  },
  loaded: {
    relationships: [],
    tags: [],
    comments: [],
  },
  // status: {
  //   tags: {
  //     1: 'loading'
  //   }
  // }
});

export const relationships = createStore(initialState, {
  [projectActions.resetReducers]: (state, action) => {
    return initialState;
  },

  '*': (state, action) => {
    if (
      action.type !== relationshipActions.patchRelationships.success &&
      action.result &&
      action.result.entities &&
      action.result.entities.relationships
    ) {
      return state.mergeDeep({
        relationships: action.result.entities.relationships,
      });
    }
    if (
      action.result &&
      action.result.entities &&
      (action.result.entities.providesTo || action.result.entities.consumesFrom)
    ) {
      let providesToRelationships = action.result.entities.providesTo
        ? action.result.entities.providesTo
        : {};
      let consumesFromRelationships = action.result.entities.consumesFrom
        ? action.result.entities.consumesFrom
        : {};

      return state.mergeDeep({
        relationships: Object.assign(
          providesToRelationships,
          consumesFromRelationships,
        ),
      });
    }
    return state;
  },

  [elementActions.deleteElement.success]: (state, action) => {
    const rels = state.get('relationships');
    const id = action.args[0].id || null;

    if (!id) return state;

    const newRels = rels.reduce((p, c) => {
      if (c.get('producer') !== id && c.get('consumer') !== id) {
        return p.set(c.get('id'), c);
      } else {
        return p;
      }
    }, Map())

    return state.set('relationships', newRels)
  },

  [projectActions.setIcon.success]: (state, action) => {
    const componentType = action.result.result.componentType;
    const componentId = action.result.result.componentId;

    if (
      componentType !== 'relationshipTypes' &&
      componentType !== 'relationships'
    )
      return state;

    return state
      .get('relationships')
      .reduce((state, relationship, index, array) => {
        if (
          relationship.get('type_id') === componentId ||
          relationship.get('id') === componentId
        ) {
          return state.setIn(
            ['relationships', index, 'icon_id'],
            action.result.result.iconId,
          );
        } else {
          return state.setIn(['relationships', index], relationship);
        }
      }, state);
  },

  [relationshipActions.deleteRelationships.success]: (state, action) => {
    action.result.relationshipIdsToDelete.forEach(rel => {
      state = state.deleteIn(['relationships', rel]);
    });

    return state;
  },

  [relationshipActions.patchRelationships.success]: (state, action) => {
    if (
      action.result &&
      action.result.entities &&
      action.result.entities.relationships
    ) {
      state = state.mergeDeep({
        relationships: action.result.entities.relationships,
      });
      const rels = action.result.entities.relationships;
      Object.keys(rels).forEach(id => {
        const rel = rels[id];
        if (rel.deleted_at) {
          state = state.deleteIn(['relationships', id]);
        }
      });
    }
    return state;
  },

  [relationshipActions.updateProperty.success]: (state, action) => {
    return state.mergeDeep({
      relationships: {
        [action.result.relationshipId]: {
          props: action.result.props,
        },
      },
    });
  },

  [relationshipActions.tearOrUntearRelationshipsBulk.success]: (
    state,
    action,
  ) => {
    return state.mergeDeep({
      relationships: action.result.entities.relationships,
    });
  },

  [relationshipActions.updateCustomProperty.success]: (state, action) => {
    const key = Object.keys(action.result.custom_props)[0];
    const value = action.result.custom_props[key];

    return state.mergeDeep({
      relationships: {
        [action.result.relationshipId]: {
          custom_props: {
            [key]: {
              _value: value,
            },
          },
        },
      },
    });
  },

  [relationshipActions.createCustomProperty.success]: (state, action) => {
    const key = Object.keys(action.result.custom_props)[0];
    const value = action.result.custom_props[key];

    return state.mergeDeep({
      relationships: {
        [action.result.relationshipId]: {
          custom_props: {
            [key]: value,
          },
        },
      },
    });
  },

  [relationshipActions.deleteRelationship.success]: (state, action) => {
    return state.deleteIn(['relationships', action.result.relationship.id]);
  },

  // [elementActions.updateCustomProperty.success]: (state, action) => {
  //   const key = Object.keys(action.result.custom_props)[0];
  //   const value = action.result.custom_props[key];

  //   return state.mergeDeep({
  //     elements: {
  //       [action.result.elementId]: {
  //         custom_props: {
  //           [key]: {
  //             value: value
  //           }
  //         }
  //       }
  //     }
  //   });
  // },

  // [elementActions.createCustomProperty.success]: (state, action) => {
  //   const key = Object.keys(action.result.custom_props)[0];
  //   const value = action.result.custom_props[key];

  //   return state.mergeDeep({
  //     elements: {
  //       [action.result.elementId]: {
  //         custom_props: {
  //           [key]: value
  //         }
  //       }
  //     }
  //   });
  // },

  // [commentActions.getElementComments.begin]: (state, action) => {
  //   const commentIds = state.getIn(['loading', 'comments']);
  //   return state.setIn(
  //     ['loading', 'comments'],
  //     commentIds.push(action.args[0]),
  //   );
  // },
  //
  // [commentActions.getElementComments.success]: (state, action) => {
  //   const commentIds = state.getIn(['loaded', 'comments']);
  //   const loadingIndex = state
  //     .getIn(['loading', 'comments'])
  //     .findIndex(function(index) {
  //       return index === action.result.id;
  //     });
  //   let loadingIds = state.getIn(['loading', 'comments']);
  //   loadingIds = loadingIds.delete(loadingIndex);
  //   return state
  //     .setIn(['loaded', 'comments'], commentIds.push(action.result.id))
  //     .setIn(['loading', 'comments'], loadingIds);
  // },

  // [tagActions.tagObject.success]: (state, action) => {
  //   if (action.args[0].taggableType !== 'Relationship') return state;
  //   if (!action.result.entities.tags) return state;
  //   // const results = action.result.entities.tags;
  //   const tagData = action.result.result;

  //   return state.setIn(['relationships', action.args[0].taggableId, 'tags'], Immutable.fromJS(tagData));
  // },

  // [tagActions.untagObject.success]: (state, action) => {
  //   if (action.args[0].taggableType !== 'Relationship') return state;
  //   if (!action.result) return state;
  //   const taggableId = action.result.taggableId;
  //   const tagId = action.result.tagId;
  //
  //   const currentTags = state.getIn(['relationships', taggableId, 'tags']);
  //   const updatedTags = currentTags.delete(currentTags.indexOf(tagId));
  //
  //   return state.setIn(['relationships', taggableId, 'tags'], updatedTags);
  // },

  // [tagActions.deleteTagFromProject.success]: (state, action) => {
  //   let r = state.get('relationships');
  //
  //   r = r.map(a => {
  //     let tags = a.get('tags');
  //
  //     if (tags) {
  //       tags = tags.filter(b => {
  //         return action.result.tagId.indexOf(b) === -1;
  //       });
  //     }
  //
  //     return a.setIn(['tags'], tags);
  //   });
  //
  //   return state.setIn(['relationships'], r);
  // },
});

export const relationshipsSelector = state =>
  state.relationships.get('relationships', List());

export const relationshipSelector = (state, props) => {
  const relId = props.relationship.get('id');
  return state.relationships.getIn(['relationships', relId]);
};

export const providesToSelector = (state, props) => {
  const providesToRelationships = elementsRelationshipsSelector(state).getIn([
    currentElementIdSelector(state, props),
    'providesTo',
  ]);

  if (!providesToRelationships) {
    return null;
  }

  const providesToElements = providesToRelationships.map(k => {
    const elementId = relationshipsSelector(state, props).getIn([
      k,
      'consumer',
    ]);
    return elementId;
  });

  return providesToElements;
};

export const consumesFromSelector = (state, props) => {
  const consumesFromRelationships = elementsRelationshipsSelector(
    state,
    props,
  ).getIn([currentElementIdSelector(state, props), 'consumesFrom']);

  if (!consumesFromRelationships) {
    return null;
  }

  const consumesFromElements = consumesFromRelationships.map(k => {
    const elementId = relationshipsSelector(state, props).getIn([
      k,
      'producer',
    ]);
    return elementId;
  });

  return consumesFromElements;
};

export const missingRelationshipsSelector = (state, props) => {
  const providesToArray = providesToSelector(state, props);
  const consumesFromArray = consumesFromSelector(state, props);

  return !providesToArray && !consumesFromArray ? true : false;
};

export const missingElementsSelector = (state, props) => {
  // eslint-disable-next-line new-cap
  const providesToArray = providesToSelector(state, props) || List();
  // eslint-disable-next-line new-cap
  const consumesFromArray = consumesFromSelector(state, props) || List();

  const relationshipsList = providesToArray.concat(consumesFromArray);

  const missingElements = relationshipsList.filter(v => {
    return (
      state.elements.getIn(['loading', 'elements']).indexOf(v) === -1 &&
      state.elements.getIn(['loaded', 'elements']).indexOf(v) === -1 &&
      !state.elements.getIn(['elements', v])
    );
  });

  return missingElements;
};

export const relationshipsByType = relationshipsState => {
  return relationshipsState.reduce((prev, rel) => {
    const relId = rel.get('type_id');
    const consumerId = rel.get('consumer');

    return prev.setIn([relId, consumerId], rel);
  }, Map());
};

export const relationshipsByTypeByRelId = relationshipsState => {
  return relationshipsState.reduce((prev, rel) => {
    const typeId = rel.get('type_id');
    const relId = rel.get('id');

    return prev.setIn([typeId, relId], rel);
  }, Map());
};



// WEBPACK FOOTER //
// ./src/reducers/relationships.js